import React from 'react'
import type { StartLabelRangeStackProps } from '@edge/spark/feature-mui-rhf-inputs'
import { StartLabelRangeStack } from '@edge/spark/feature-mui-rhf-inputs'

export const RangeField: React.VFC<StartLabelRangeStackProps> = ({
    selectProps,
    lowProps,
    highProps,
    ...restProps
}: StartLabelRangeStackProps) => {
    return (
        <StartLabelRangeStack
            selectProps={{
                sx: { minWidth: 0.4 },
                fullWidth: true,
                variant: 'standard',
                ...selectProps,
            }}
            lowProps={{
                fullWidth: true,
                variant: 'standard',
                valueAsNumber: false,
                ...lowProps,
            }}
            highProps={{
                fullWidth: true,
                variant: 'standard',
                valueAsNumber: false,
                ...highProps,
            }}
            {...restProps}
        />
    )
}
